import { InjectionToken } from '@angular/core';

export type BuildEnvironment = 'develop' | 'qa' | 'staging' | 'sandbox' | 'production';

export interface AppConfig {
  name: BuildEnvironment;
  apiHost: string;
  production: boolean;
}

export const APP_ENV_CONFIG = new InjectionToken<AppConfig>('Application Environment Config');

export const getEnvironment = (): AppConfig => {
  switch (window.location.host) {
    case 'mocketbnk.rocketkor.net':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://api.rocketkor.net',
      };
    case 'testbank.salttreasury.com':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://api.salttreasury.com',
      };
    case 'mocketbnk.sandbox.rocketkor.net':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://api.sandbox.rocketkor.net',
      };
    case 'testbank.sandbox.salttreasury.com':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://api.sandbox.salttreasury.com',
      };
    case 'mocketbnk.staging.rocketkor-nonprod.net':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://api.staging.rocketkor-nonprod.net',
      };
    case 'testbank.staging.salttreasury.com':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://api.staging.salttreasury.com',
      };
    case 'rocketkor-qa-mocketbnk-frontend.web.app':
    case 'rocketkor-qa-mocketbnk-frontend.firebaseapp.com':
    case 'mocketbnk.qa.rocketkor-nonprod.net':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.rocketkor-nonprod.net',
      };
    case 'testbank.qa.salttreasury.com':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.salttreasury.com',
      };
    case 'rocketkor-dev-mocketbnk-frontend.web.app':
    case 'rocketkor-dev-mocketbnk-frontend.firebaseapp.com':
    case 'mocketbnk.dev.rocketkor-nonprod.net':
      return {
        name: 'develop',
        production: false,
        apiHost: 'https://api.dev.rocketkor-nonprod.net',
      };
    default:
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.rocketkor-nonprod.net',
      };
  }
};
